(function () {
  const WA_URL = "https://api.whatsapp.com/send/?phone=85260333999";

  function normalize(wrap) {
    // 1) 去重：同一个区域里只保留一个 add-to-cart 按钮（主题可能重复渲染）
    const atcButtons = wrap.querySelectorAll(".add-to-cart-button");
    if (atcButtons.length > 1) {
      for (let i = 1; i < atcButtons.length; i++) {
        const btn = atcButtons[i];
        // 删除按钮所在的外层容器（更干净）
        const container = btn.closest("add-to-cart-component") || btn;
        container.remove();
      }
    }

    const atc = wrap.querySelector(".add-to-cart-button");
    if (!atc) return;

    // 2) 判断缺货：优先用 disabled，其次用文案兜底
    const text = (atc.textContent || "").toLowerCase();
    const soldOut = atc.hasAttribute("disabled") || text.includes("sold out");

    // 3) 先清理旧的 enquire（避免重复）
    const existingEnquire = wrap.querySelector(".enquire-whatsapp-btn");
    if (existingEnquire && !soldOut) existingEnquire.remove();

    if (soldOut) {
      // 缺货：隐藏所有 add to cart（不管 disabled 与否，防止误导）
      wrap.querySelectorAll(".add-to-cart-button").forEach((b) => {
        b.style.display = "none";
      });

      // 没有 enquire 才创建
      if (!existingEnquire) {
        const a = document.createElement("a");
        a.className = "button enquire-whatsapp-btn";
        a.href = WA_URL;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        a.textContent = "Enquire for more";
        wrap.insertBefore(a, wrap.firstChild);
      }
    } else {
      // 有货：显示 add to cart，并确保 enquire 不在
      wrap.querySelectorAll(".add-to-cart-button").forEach((b) => {
        b.style.display = "";
      });
      if (existingEnquire) existingEnquire.remove();
    }
  }

  function run(root = document) {
    root.querySelectorAll(".product-form-buttons").forEach(normalize);
  }

  document.addEventListener("DOMContentLoaded", () => run());

  // 监听 DOM 变化（变体切换/局部刷新会触发）
  const obs = new MutationObserver(() => run());
  obs.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
  });

  // 监听 change（很多主题切换变体会触发 change）
  document.addEventListener("change", () => run(), true);
})();
